import React, { useState } from 'react';
import { ShoppingCart, CheckCircle2, ShieldCheck } from 'lucide-react';
export function ProductInfo() {
  const [qty, setQty] = useState(1);
  return <div className="flex flex-col gap-6" data-id="element-100">
      <div data-id="element-101">
        <h1 className="text-2xl md:text-3xl font-bold text-brand-charcoal leading-tight mb-4" data-id="element-102">
          1/8" VI-Pro Corner Radius End Mill Carbide 4 Flute Vari Index Stub
          Length AlCrN Coated TITAN CR=.005"
        </h1>

        <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-2" data-id="element-103">
          <span className="font-semibold text-brand-charcoal" data-id="element-104">SKU:</span>
          <span className="bg-gray-100 px-2 py-0.5 rounded font-mono" data-id="element-105">
            TC20960
          </span>

          <span className="text-gray-300" data-id="element-106">|</span>

          <span className="flex items-center gap-1 text-green-700 font-medium" data-id="element-107">
            <ShieldCheck className="w-4 h-4" data-id="element-108" />
            All items proudly made in the USA!
          </span>
        </div>
      </div>

      <div className="bg-brand-gray border border-gray-200 rounded-lg p-6" data-id="element-109">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-6" data-id="element-110">
          <div data-id="element-111">
            <div className="text-4xl font-bold text-brand-red mb-2" data-id="element-112">$20.89</div>
            <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-113">
              <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-114" />
              <span data-id="element-115">
                Available: <strong className="text-brand-charcoal" data-id="element-116">71</strong>
              </span>
              <span className="text-gray-300 mx-1" data-id="element-117">|</span>
              <span data-id="element-118">
                Package Qty: <strong data-id="element-119">1</strong>
              </span>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-120">
            <div className="flex flex-col gap-1" data-id="element-121">
              <label htmlFor="qty" className="text-xs font-semibold text-gray-600 uppercase" data-id="element-122">
                Qty
              </label>
              <input type="number" id="qty" min="1" value={qty} onChange={e => setQty(Math.max(1, parseInt(e.target.value) || 1))} className="w-20 border border-gray-300 rounded px-3 py-2 text-center font-semibold focus:outline-none focus:border-brand-darkGold focus:ring-1 focus:ring-brand-darkGold" data-id="element-123" />
            </div>
            <button className="bg-brand-lightGold hover:bg-brand-darkGold border border-brand-darkGold text-black font-bold px-6 py-2 rounded-md flex items-center justify-center gap-2 whitespace-nowrap transition-colors mt-5 shadow-sm" data-id="element-124">
              <ShoppingCart className="w-5 h-5 flex-shrink-0" data-id="element-125" />
              ADD TO CART
            </button>
          </div>
        </div>
      </div>
    </div>;
}